/* Call Time: shared site behaviour
   No localStorage: sandboxed iframes block storage. Theme state is in-memory. */

/* ============================================================
   KLAVIYO CONFIG
   COMPANY_ID is the public API key / site ID. It is public by design and
   safe in front-end code, because it can only create subscriptions and never reads data.
   LIST_ID is the ID of the single "Sunday Call Sheet" list. Find it in
   Klaviyo under Audience > Lists & Segments > (open the list) > Settings,
   or read it out of the URL. Leave LIST_ID empty to fall back to the
   in-memory demo behaviour.
   ============================================================ */
var CT_KLAVIYO = {
  COMPANY_ID: 'VCEFQs',
  LIST_ID: 'WTc2Z3',
  REVISION: '2026-01-15'
};

(function () {
  'use strict';

  /* ---------------- Theme toggle ---------------- */
  var root = document.documentElement;

  function currentTheme() {
    return root.getAttribute('data-theme') || 'light';
  }

  function setTheme(next) {
    root.setAttribute('data-theme', next);
    document.querySelectorAll('.theme-toggle').forEach(function (btn) {
      btn.setAttribute('aria-label', next === 'dark' ? 'Switch to light theme' : 'Switch to dark theme');
      btn.setAttribute('aria-pressed', String(next === 'dark'));
    });
  }

  document.querySelectorAll('.theme-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
    });
  });
  setTheme(currentTheme());

  /* ---------------- Mobile nav ---------------- */
  var navToggle = document.querySelector('.ct-nav-toggle');
  var nav = document.getElementById('primary-nav');

  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', String(!open));
      navToggle.setAttribute('aria-expanded', String(!open));
    });
    nav.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        nav.setAttribute('data-open', 'false');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('data-open') === 'true') {
        nav.setAttribute('data-open', 'false');
        navToggle.setAttribute('aria-expanded', 'false');
        navToggle.focus();
      }
    });
  }

  /* ---------------- Scroll reveal ---------------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------------- Waitlist / email forms ----------------
     Posts to Klaviyo's client-side subscriptions endpoint, which accepts the
     public API key only. Falls back to an in-memory record when LIST_ID is
     unset so the preview still demonstrates the success state. */
  var captured = [];
  window.__ctCaptured = captured;

  function isEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v.trim());
  }

  function klaviyoReady() {
    return Boolean(CT_KLAVIYO.COMPANY_ID && CT_KLAVIYO.LIST_ID);
  }

  function subscribe(email, props, source) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' +
      encodeURIComponent(CT_KLAVIYO.COMPANY_ID);

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: props
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: CT_KLAVIYO.LIST_ID } }
        }
      }
    };

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': CT_KLAVIYO.REVISION
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.status === 202 || res.ok) return true;
      return res.text().then(function (t) {
        throw new Error('Klaviyo ' + res.status + ': ' + t.slice(0, 300));
      });
    });
  }

  document.querySelectorAll('form[data-capture]').forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var errorEl = form.querySelector('.ct-field-error');
    var success = document.getElementById(form.dataset.successTarget);
    var button = form.querySelector('button[type="submit"]');
    var buttonLabel = button ? button.textContent : '';
    var busy = false;

    function fail(message) {
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }

    function showSuccess(value) {
      if (!success) return;
      var named = success.querySelector('[data-echo-email]');
      if (named) named.textContent = value;
      form.hidden = true;
      success.hidden = false;
      success.setAttribute('tabindex', '-1');
      success.focus();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;

      var value = input.value.trim();

      if (!isEmail(value)) {
        fail(value ? 'That does not look like an email address yet.'
                   : 'Add your email and we will send the next one.');
        return;
      }

      input.removeAttribute('aria-invalid');
      if (errorEl) errorEl.hidden = true;

      var interestField = form.querySelector('[name="interest"]');
      var interestLabel = null;
      if (interestField) {
        var opt = interestField.options[interestField.selectedIndex];
        interestLabel = opt ? opt.textContent.trim() : interestField.value;
      }

      var source = form.dataset.source || form.dataset.list || 'website';
      var props = {
        'Signup Source': source,
        'Brand': 'Call Time'
      };
      if (interestLabel) {
        props['First Need'] = interestLabel;
        props['First Need Key'] = interestField.value;
      }

      captured.push({ email: value, source: source, interest: interestLabel, at: new Date().toISOString() });

      if (!klaviyoReady()) {
        showSuccess(value);
        return;
      }

      busy = true;
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding you\u2026';
      }

      subscribe(value, props, source)
        .then(function () {
          showSuccess(value);
        })
        .catch(function (err) {
          if (window.console) console.error(err);
          fail('Something went wrong on our end. Give it one more try in a moment.');
        })
        .then(function () {
          busy = false;
          if (button) {
            button.disabled = false;
            button.textContent = buttonLabel;
          }
        });
    });

    input.addEventListener('input', function () {
      if (errorEl && !errorEl.hidden) { errorEl.hidden = true; }
      input.removeAttribute('aria-invalid');
    });
  });

  /* ---------------- Waitlist deep-link from product buttons ---------------- */
  document.querySelectorAll('[data-want]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var select = document.querySelector('#waitlist-interest');
      if (select) {
        var wanted = btn.dataset.want;
        Array.prototype.forEach.call(select.options, function (opt) {
          if (opt.value === wanted) select.value = wanted;
        });
      }
    });
  });

  /* ---------------- Footer year ---------------- */
  document.querySelectorAll('[data-year]').forEach(function (el) {
    el.textContent = String(new Date().getFullYear());
  });
})();
